import React from 'react';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import Select2DropdownList from '../../FormElements/Select2DropdownList';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditUserLoginDataForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			emailAddressPrincipal: '',
			globalErrors: [],
			fieldErrors: {},
			userData: {
				summaryData: {
					summary: {
						roles: []
					}
				}
			}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
	}

	componentDidMount() {
		const { iam_get_user_login_endpoint, userData } = this.props;
		if (iam_get_user_login_endpoint && userData && userData.summaryData) {
			this.loadData(
				userData &&
					userData.summaryData &&
					userData.summaryData.summary &&
					userData.summaryData.summary.roles
			);
		}
	}

	componentDidUpdate(prevProps) {
		const { iam_get_user_login_endpoint, userData } = this.props;
		if (prevProps.iam_get_user_login_endpoint !== iam_get_user_login_endpoint) {
			this.loadData(
				userData &&
					userData.summaryData &&
					userData.summaryData.summary &&
					userData.summaryData.summary.roles
			);
		}
	}

	render() {
		// console.log('EditUserLoginDataForm - render - this.state', this.state);
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="mb-3">
							<Label>{I18n.t('admin.user_profile.roles')}</Label>
							<Select2DropdownList
								placeholder={I18n.t('admin.user_profile.assign_roles')}
								name="role"
								value={this.state.userData.summaryData.summary.roles}
								endpoint={this.props.iam_get_user_roles_endpoint}
								isMulti={true}
								style={{ width: '100%', display: 'block' }}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>
								{I18n.t('admin.user_profile.email_address_principal')}
							</Label>
							<TextInput
								style={this.styleTextInputOnError('emailAddressPrincipal')}
								placeholder=""
								name="emailAddressPrincipal"
								value={this.state.emailAddressPrincipal}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={I18n.t(
							'admin.user_profile.update_user_profile_submit_button'
						)}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors && fieldName in this.state.fieldErrors) {
			return { border: '1px solid #ff3d60', borderRadius: '5px' };
		}
		return {};
	}

	onChange(e) {
		// console.log('EditUserLoginDataForm - onChange - e', e);
		let { name, value, id, text } = e.target;

		if (e.isSelect2) {
			this.setState(
				(prevState) => {
					const { roles } = prevState.userData.summaryData.summary;
					// console.log('roles', roles);

					// If role doesn't exist and is not deleted, add it
					const updatedRoles = e.isDeleted
						? roles.filter((role) => role.name !== id)
						: !roles.some((role) => role.name === id)
							? [
									...roles,
									{ name: value, scope: 'CHANNEL', displayAs: text }
								]
							: roles;

					// console.log('updatedRoles', updatedRoles);

					return {
						userData: {
							summaryData: {
								summary: {
									roles: updatedRoles
								}
							}
						}
					};
				},
				() => {
					// Log the updated state after setState is complete
					// console.log('Updated state:', this.state);
				}
			);
		} else {
			this.setState({ [name]: value });
		}
	}

	onSetFieldError(errorsArray, error) {
		return errorsArray.includes(error) ? 'Error' : {};
	}

	onSubmit = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true,
			globalErrors: [], // Clear previous errors
			fieldErrors: {} // Clear previous errors
		});

		const {
			userId,
			userData,
			iam_update_user_profile_endpoint,
			iam_update_user_roles_endpoint
		} = this.props;

		const {
			emailAddressPrincipal,
			userData: { summaryData: { summary: { roles = [] } = {} } = {} }
		} = this.state;

		try {
			// Update user profile
			const profileResponse = await this.sendAjaxRequest(
				'POST',
				iam_update_user_profile_endpoint,
				{
					user_id: userId,
					presentationId: userData.loginData.presentationId,
					emailAddressPrincipal: emailAddressPrincipal
				}
			);

			if (profileResponse.status === 'success') {
				// Update user roles
				const rolesResponse = await this.sendAjaxRequest(
					'PUT',
					iam_update_user_roles_endpoint,
					{
						user_id: userId,
						roles: roles.map((role) => role.name)
					}
				);

				if (rolesResponse.status === 'success') {
					this.setState({
						loading: false
					});
					this.props.updateLoginData(profileResponse.data);
					this.props.updateRolesData(rolesResponse.data);
					this.props.onHidePopup();
					this.props.onShowSuccessCardPopup();
				} else if (rolesResponse.status === 'session_expired') {
					this.props.onHidePopup();
					this.props.onShowTimeoutCardPopup(
						setTimeout(() => {
							window.location.href = `/admin/${this.props.public_id}/signin`;
						}, 5000)
					);
				} else if (rolesResponse.data) {
					this.setState({
						loading: false,
						globalErrors: rolesResponse.data.global,
						fieldErrors: rolesResponse.data.fields
					});
				} else {
					// Handle unexpected response format for rolesResponse
				}
			} else if (profileResponse.status === 'session_expired') {
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else if (profileResponse.data) {
				this.setState({
					loading: false,
					globalErrors: profileResponse.data.global,
					fieldErrors: profileResponse.data.fields
				});
			} else {
				// Handle unexpected response format for profileResponse
			}
		} catch (error) {
			// Handle submission error
		}
	};

	sendAjaxRequest = (type, url, data) => {
		return new Promise((resolve, reject) => {
			$.ajax({
				type: type,
				url: url,
				data: data,
				dataType: 'json'
			})
				.done((data) => {
					resolve(data);
				})
				.fail((error) => {
					reject(error);
				});
		});
	};

	loadData(roles) {
		// console.log('EditUserLoginDataForm - loadData - roles', roles);
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.iam_get_user_login_endpoint,
			data: {
				user_id: this.props.userData.summaryData.id
			}
		}).done((payload) => {
			const result = payload;
			// console.log('User Profile data loaded!', result);
			this.setState({
				loading: false,
				emailAddressPrincipal:
					result &&
					result.data &&
					result.data.fields &&
					result.data.fields[1].value &&
					result.data.fields[1].value.asString,
				userData: {
					summaryData: {
						summary: {
							roles: roles
						}
					}
				}
			});
		});
	}
}
